/**
 * Generates the per-send `clientTurnId` (uuid v4).
 *
 * `crypto.randomUUID` only exists in secure contexts (https / localhost), so
 * plain-http LAN testing and older browsers fall back to an RFC 4122 v4 id
 * built from `getRandomValues` (or `Math.random` as a last resort).
 */
export function generateClientTurnId(): string {
   const cryptoApi: any = typeof globalThis !== 'undefined' ? (globalThis as any).crypto : undefined;

   if (cryptoApi && typeof cryptoApi.randomUUID === 'function') {
      try {
         return cryptoApi.randomUUID();
      } catch {
         // fall through to the manual implementation
      }
   }

   const bytes = new Uint8Array(16);
   if (cryptoApi && typeof cryptoApi.getRandomValues === 'function') {
      cryptoApi.getRandomValues(bytes);
   } else {
      for (let i = 0; i < bytes.length; i++) bytes[i] = Math.floor(Math.random() * 256);
   }

   bytes[6] = (bytes[6] & 0x0f) | 0x40; // version 4
   bytes[8] = (bytes[8] & 0x3f) | 0x80; // RFC 4122 variant

   let hex = '';
   for (let i = 0; i < bytes.length; i++) hex += bytes[i].toString(16).padStart(2, '0');
   return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export const UUID_V4_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
